import { Folder, Identifiable } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function saveFolder(httpClient: HttpClient) {
  return (parentFolder: Identifiable<Folder>, folder: Folder) =>
    httpClient.sendHttpRequest<Identifiable<Folder>>({
      endpoint: "/api/folders",
      method: HttpMethods.POST,
      data: {
        name: folder.name,
        description: folder.description,
        parent: `/folder/${parentFolder.uuid}`,
        ...(folder.projectUuid ? { projectUuid: folder.projectUuid } : {}),
        ...(folder.planzoneUuid ? { planzoneUuid: folder.planzoneUuid } : {}),
      },
    });
}

export { saveFolder };
